import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminUserProductionTypeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number", width: 100 },
                    { key: "name", name: "Name", type: "string"},
                    { key: "description", name: "Description", type: "string"},
                ]}
                sort={[
                    {
                        key: "id",
                        direction: "ascending",
                        type: "number"
                    }
                ]}
                rows={Object.values(this.context.userProductionTypesIndexed)}
                onClick={(userProductionType) => {
                    this.props.history.push({
                        pathname: "/admin/userProductionType/" + userProductionType.id
                    });
                }}
            />
        );
    }
});